export default __webpack_public_path__ + "static/media/dotsFilled.c7e6b099.svg";